import { createAction } from "@reduxjs/toolkit";
import { NFTExport } from "../../../models/exports";

export const addNft = createAction<NFTExport>("addNft/addNft");
export const removeNft = createAction<NFTExport>("addNft/removeNft");
export const clearNft = createAction<NFTExport>("addNft/clearNft");
